export default __webpack_public_path__ + "static/2-5200d4a58fafb54226848e13ddc2507d.png";